import { render, staticRenderFns } from "./NewAjuste.vue?vue&type=template&id=43f0ce2e&scoped=true"
import script from "./NewAjuste.vue?vue&type=script&lang=js"
export * from "./NewAjuste.vue?vue&type=script&lang=js"
import style0 from "./NewAjuste.vue?vue&type=style&index=0&id=43f0ce2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f0ce2e",
  null
  
)

export default component.exports